import { createAsyncAction } from "typesafe-actions";
import { deleteThumbnailApi } from "./exhibits.api";
import {ExhibitDto} from './exhibits.dtos';

export const exhibitActions = createAsyncAction(
    'GET_EXHIBIT_REQUEST',
    'GET_EXHIBIT_SUCCESS',
    'GET_EXHIBIT_ERROR',
  )<string, ExhibitDto, string>();
  
  export const exhibitsActions = createAsyncAction(
    'GET_EXHIBITS_REQUEST',
    'GET_EXHIBITS_SUCCESS',
    'GET_EXHIBITS_ERROR',
  )<string, ExhibitDto[], string>();
  
  export const updateExhibitActions = createAsyncAction(
    'UPDATE_EXHIBIT_REQUEST',
    'UPDATE_EXHIBIT_SUCCESS',
    'UPDATE_EXHIBIT_ERROR',
  )<ExhibitDto, ExhibitDto, string>();
  
  export const createExhibitActions = createAsyncAction(
    'CREATE_EXHIBIT_REQUEST',
    'CREATE_EXHIBIT_SUCCESS',
    'CREATE_EXHIBIT_ERROR',
  )<ExhibitDto, ExhibitDto, string>();
  
  export const deleteThumbnailAction = (id: string, fileName: string) => deleteThumbnailApi(id, fileName);